import { render, staticRenderFns } from "./pending-packaging.vue?vue&type=template&id=aa2f7aa4&"
import script from "./pending-packaging.vue?vue&type=script&lang=js&"
export * from "./pending-packaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports